export default __webpack_public_path__ + "static/media/at2_admin_logo_new.66c5102d.svg";